export const REACT_APP_AUTH_CLIENTID = "__REACT_APP_AUTH_CLIENTID__";
export const REACT_APP_AUTH_AUTHORITY = "__REACT_APP_AUTH_AUTHORITY__";
export const REACT_APP_AUTH_REDIRECT_URI = "__REACT_APP_AUTH_REDIRECT_URI__";
export const REACT_APP_AUTH_SCOPE = "__REACT_APP_AUTH_SCOPE__";
export const REACT_APP_BACKENDURL = "__REACT_APP_BACKENDURL__";
export const REACT_APP_CRYSTALURL = "__REACT_APP_CRYSTALURL__";

/**
 * List of style names that should be converted to black text in EditorV3 content.
 * These styles are removed from text blocks, resulting in default (black) text appearance.
 * Used for removing green highlighting from Optional and OptionalLocked blocks.
 *
 * @readonly
 */
export const STYLES_TO_CLEAN = ["Optional", "OptionalLocked"];
/**
 * List of style names for which entire text blocks should be removed from EditorV3 content.
 * Used for removing blue Notes blocks entirely from the output.
 *
 * @readonly
 */
export const STYLES_TO_DELETE = ["Notes"];
